const utils = {
  toHour: (i) => [i.toString().padStart(2, '0'), ':00'].join(''),
};

export default utils;
